import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from './../../Providers/AuthProvider'


const Login = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const { login, isAuthenticated, role } = useAuth()
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const redirectUser = (userRole) => {
        const from = location.state?.from?.pathname
        if (from && from !== '/login' && from !== '/admin') {
            navigate(from, { replace: true })
            return
        }

        if (userRole === 'sound_operator') {
            navigate('/admin/playlist/cabina', { replace: true })
        } else {
            navigate('/admin/dashboard', { replace: true })
        }
    }

    useEffect(() => {
        if (isAuthenticated) {
            const userRole = (role || localStorage.getItem('role') || '').toLowerCase()
            redirectUser(userRole)
        }
    }, [isAuthenticated, role, navigate])

    // Función principal para iniciar sesión
    const handleLogin = async (event) => {
        if (event) {
            event.preventDefault()
        }

        try {
            setError(null)

            // Validaciones básicas antes de enviar
            if (!username.trim()) {
                setError('Escribe tu usuario')
                return
            }

            if (!password.trim()) {
                setError('Escribe tu contraseña')
                return
            }

            setIsLoading(true)

            // Llamar a login del AuthProvider
            const response = await login(username, password)

            if (response.success) {
                const userRole = (
                    response.data?.user?.role ||
                    response.data?.role ||
                    role ||
                    localStorage.getItem('role') ||
                    ''
                ).toLowerCase()

                redirectUser(userRole)
            } else {
                setError(response.message || 'Usuario o contraseña incorrectos')
            }
        } catch (err) {
            console.error(err)
            setError('Ha habido un error al intentar iniciar sesión. Inténtalo nuevamente o inténtalo más tarde.')
        } finally {
            setIsLoading(false)
        }
    }

    // Detectar tecla Enter en el formulario
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault()
            if (!isLoading) {
                handleLogin()
            }
        }
    }


    return (
        <main className="container Login">
            <div className="row Login__Container">
                <div className="row">
                    <img src="/img/page/adsl-five-bicolor.png" className="LogoADSLxZtudia" alt="Logo" />

                    <h1 className="mt-2 text-center fs-4">Iniciar sesión</h1>

                    <form className="mt-4" onSubmit={handleLogin} onKeyDown={handleKeyDown}>
                        <div className="mb-3">
                            <input
                                type="text"
                                className="form-control"
                                id="txtUser"
                                placeholder="Usuario"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                autoComplete="username"
                                disabled={isLoading}
                            />
                        </div>

                        <div className="mb-3">
                            <input
                                type="password"
                                className="form-control"
                                id="txtPassword"
                                placeholder="Contraseña"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                                disabled={isLoading}
                            />
                        </div>

                        <button 
                            type="button" 
                            className="Btn__Adsl--Red" 
                            onClick={handleLogin} 
                            disabled={isLoading}
                        >
                            {isLoading ? 'Iniciando...' : 'Iniciar sesión'}
                        </button>

                        {error && error !== '' && (
                            <p className="text-center text-danger mt-3">{error}</p>
                        )}
                    </form>
                </div>
            </div>
        </main>
    )
}

export { Login };